import { render, staticRenderFns } from "./MedicalRepForm.vue?vue&type=template&id=7238a7ed&"
import script from "./MedicalRepForm.vue?vue&type=script&lang=ts&"
export * from "./MedicalRepForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports